import { render } from "./VoteStats.vue?vue&type=template&id=26c1bea3&scoped=true"
import script from "./VoteStats.vue?vue&type=script&lang=js"
export * from "./VoteStats.vue?vue&type=script&lang=js"

import "./VoteStats.vue?vue&type=style&index=0&id=26c1bea3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c1bea3"]])

export default __exports__